import { RAW_MATERIAL_INWARD_CHALLAN_REQUEST, CREATE_RAW_MATERIAL_INWARD_CHALLAN, GET_RAW_MATERIAL_INWARD_CHALLANS, UPDATE_RAW_MATERIAL_INWARD_CHALLAN, DELETE_RAW_MATERIAL_INWARD_CHALLAN, RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE } from '../types';

const initialState = {
  rawMaterialInwardChallans: [],
  loading: false,
  error: null,
};

const rawMaterialInwardChallanReducer = (state = initialState, action) => {
  switch (action.type) {
    case RAW_MATERIAL_INWARD_CHALLAN_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RAW_MATERIAL_INWARD_CHALLANS: {
      return {
        ...state,
        rawMaterialInwardChallans: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_RAW_MATERIAL_INWARD_CHALLAN:
      return {
        ...state,
        rawMaterialInwardChallans: [action.payload, ...state.rawMaterialInwardChallans],
        loading: false,
        error: null
      };
    case UPDATE_RAW_MATERIAL_INWARD_CHALLAN:
      const rawMaterialInwardChallansData = state.rawMaterialInwardChallans.slice(0);
      const uIndex = rawMaterialInwardChallansData.findIndex((data) => data.id === action.payload.id);
      rawMaterialInwardChallansData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        rawMaterialInwardChallans: [ ...rawMaterialInwardChallansData ],
        loading: false,
        error: null
      };
    case DELETE_RAW_MATERIAL_INWARD_CHALLAN:
      const rawMaterialInwardChallans = state.rawMaterialInwardChallans?.slice(0);
      const index = rawMaterialInwardChallans.findIndex((data) => data.id === action.id);
      if (index > -1) {
        rawMaterialInwardChallans.splice(index, 1);
      }
      return {
        ...state,
        rawMaterialInwardChallans: [...rawMaterialInwardChallans],
        loading: false,
        error: null
      }
    case RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default rawMaterialInwardChallanReducer;
